import { cloneDeep } from 'lodash-es';

import type { IRecord } from '@gp/types/global';

export const getOptionValues = (options?: IGPSelectOptionWithGroup[] | null): string[] => {
  if (!Array.isArray(options) || !options.length) return [];
  return options.map((option) => option?.value);
};

export const getSafetyValues = (
  required: boolean,
  values?: string[] | null,
  options?: IGPSelectOptionWithGroup[] | null,
): string[] => {
  if (!Array.isArray(options) || !options.length) return [];
  if (!Array.isArray(values) || !values.length) return !required ? [] : getOptionValues(options);
  return values;
};

export const getSortedValues = (
  required: boolean,
  values?: string[] | null,
  options?: IGPSelectOptionWithGroup[] | null,
): string[] => {
  if (!Array.isArray(options) || !options.length) return [];
  if (!Array.isArray(values) || !values.length) return !required ? [] : getOptionValues(options);
  const valuesTmp = cloneDeep(values);

  valuesTmp.sort((a, b) => {
    let aIdx = -1;
    let bIdx = -1;

    for (let i = 0; i < options.length; i++) {
      const { value } = options?.[i] || {};
      if (value === a) {
        aIdx = i;
      }
      if (value === b) {
        bIdx = i;
      }
      if (aIdx !== -1 && bIdx !== -1) break;
    }

    return aIdx - bIdx;
  });

  return valuesTmp;
};

export const getDividedOptions = (
  options?: IGPSelectOptionWithGroup[] | null,
  values?: string[] | null,
): IGPSelectOptionWithGroup[] => {
  if (!Array.isArray(options) || !options.length) return [];
  if (!Array.isArray(values) || !values.length) return options;
  const selectedOptions: IGPSelectOptionWithGroup[] = [];
  const unselectedOptions: IGPSelectOptionWithGroup[] = [];
  const valuesMap = values.reduce<IRecord<boolean>>((acc, cur) => {
    return { ...acc, [cur]: true };
  }, {});

  for (const option of options) {
    const { value } = option || {};
    if (valuesMap[value]) {
      selectedOptions.push(option);
    } else {
      unselectedOptions.push(option);
    }
  }

  return [...selectedOptions, ...unselectedOptions];
};
